import React from 'react';
import PanelTakeaway from '../shared/PanelTakeaway';
import InfoTip from '../shared/InfoTip';
import PlaceRow from './answers/PlaceRow';
import { CARD_LIST, CARD_TITLE } from './liStyles';

// Open tonight (before 7 PM) / Open now (after) — places to eat and things to do that
// are open, ranked. The count line is the database's; "See all" opens the full list.
const OpenTonight = ({ panel, onOpen, onOpenDrill }) => {
  const facts = panel?.facts || {};
  const picks = Array.isArray(facts.picks) ? facts.picks : [];
  return (
    <section id="panel-open_now" className={CARD_LIST} aria-label={panel?.title || 'Open tonight'}>
      <div className="px-4 sm:px-5 pt-4">
        <h2 className={CARD_TITLE}>
          {panel?.title || 'Open tonight'}
          <InfoTip text="Places to eat and things to do that are open, within a 20-minute drive. Hours are checked against each place's own listing." />
        </h2>
        {facts.open_label && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{facts.open_label}</p>}
        <div className="mt-2"><PanelTakeaway sentence={panel?.sentence} /></div>
      </div>
      {picks.length === 0 ? (
        <p className="px-4 sm:px-5 pb-4 text-sm text-gray-500 dark:text-gray-400">Nothing is open within 20 minutes at this hour.</p>
      ) : (
        <div className="divide-y divide-gray-100 dark:divide-gray-800 border-t border-gray-100 dark:border-gray-800">
          {picks.map((p) => <PlaceRow key={p.entity_id} place={p} onOpen={onOpen} />)}
        </div>
      )}
      {facts.drill && (facts.open_within_20_min || 0) > picks.length && (
        <div className="px-4 sm:px-5 py-3 border-t border-gray-100 dark:border-gray-800">
          <button type="button" className="text-sm font-medium text-[#32B1FF] hover:underline" onClick={() => onOpenDrill(facts.drill)}>
            See all {facts.open_within_20_min}
          </button>
        </div>
      )}
    </section>
  );
};

export default OpenTonight;
